import {color} from "#graph/serialization/color"
import {z} from "zod"

export const editorNodeUiSchema = z
    .object({
        internalColor: color.optional(),
        internalLabel: z.string().optional(),
        position: z.object({
            x: z.number(),
            y: z.number(),
        }),
    })
    .optional()
